/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/words-learnt.js';
import DateHelper from '../classes/date.js';

const dataKeys = [{key:'reading' , fill:'#fd470a'} , {key:'listening' , fill:'#ff8417'} , {key:'writing' , fill:'#fa74b7'} , {key:'speaking' , fill:'#1b9ff6'}];


class WordsLearntStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.accountLevelCommunicative = [];
        this.accountLevel = [];
        this.classLevelCommunicative = [];
        this.total = 0;
    }

    _orderDates(items){

        function functiontofindIndexByKeyValue(arraytosearch, key, valuetosearch) {

            console.log(arraytosearch);
            for (var i = 0; i < arraytosearch.length; i++) {

                if (arraytosearch[i][key] == valuetosearch) {
                    return i;
                }
            }
            return null;
        }

        var itemsOrdered = [];
        var theOrder = [ "7", "8", "9", "10", "11", "12", "1" , "2" , "3" , "4" , "5" , "6"];

        for (var i = 0; i < theOrder.length; i++) {

            var index = functiontofindIndexByKeyValue(items , "index" , theOrder[i]);

            if(index > -1)
            {
                if(typeof items[index] != "undefined")
                {
                    itemsOrdered.push(items[index]);
                }
            }
        }


        console.log(itemsOrdered)
        return itemsOrdered;
    }

    _processLineGraphCommunicative(data){


        console.log(data);
        var response = [];
        for(var key in data){
            if(!data.hasOwnProperty(key)) continue;
            var entry =  data[key];

            response.push({month:entry.month , index:Number(entry.month) , name:(new DateHelper()).getMonthTranslation(entry.month) , total_reading:Number(entry.total_reading) , total_speaking:Number(entry.total_speaking) , total_writing:Number(entry.total_writing) , total_listening:Number(entry.total_listening) , words:Number(Number(entry.total_speaking)+ Number(entry.total_writing) + Number(entry.total_reading) + Number(entry.total_listening))})
        }

        //response.sort(function(a, b){return Number(a.index) - Number(b.index)});
        return this._orderDates(response);
    }

    _processNoCommunicative(data){

        var response = [];
        for(var key in data){
            if(!data.hasOwnProperty(key)) continue;
            var entry =  data[key];

            response.push({month:entry.month , index:Number(entry.month) , name:(new DateHelper()).getMonthTranslation(entry.month) , speaking:Number(entry.speaking) , writing:Number(entry.writing) , reading:Number(entry.reading) , listening:Number(entry.listening)});
        }

      //  response.sort(function(a, b){return Number(a.index) - Number(b.index)});

        return this._orderDates(response);
    }

    _processTotalWordsCommunicative(data){

        var response = [];
        for(var key in data){
            if(!data.hasOwnProperty(key)) continue;
            var entry =  data[key];

            response.push({index:Number(entry.month) , name:(new DateHelper()).getMonthTranslation(entry.month) , speaking:Number(entry.speaking) , writing:Number(entry.writing) , reading:Number(entry.reading) , listening:Number(entry.listening)});
        }

        //response.sort(function(a, b){return Number(a.index) - Number(b.index)});

        return this._orderDates(response);
    }

    _processCommunicative(data){

        console.log(data)
        var response = [];

        for(var key in data){
            if(!data.hasOwnProperty(key)) continue;
            var entry =  data[key];
            response.push({index:Number(entry.month) , name:(new DateHelper()).getMonthTranslation(entry.month) , words:entry.words || 0})
        }

        //response.sort(function(a, b){return Number(a.index) - Number(b.index)});

        return this._orderDates(response);
    }

    _registerToActions(action) {

        switch(action.actionType)
        {
            case Constants.UPDATE_ACCOUNT_LEVEL_SKILLS:
                this.accountLevelSkillsCommunicative = this._processLineGraphCommunicative(action.response);
                this.emitChange();
                break;
            case Constants.UPDATE_ACCOUNT_LEVEL:
                this.accountLevelCommunicative = this._processCommunicative(action.response);
                this.emitChange();
                break;
            case Constants.UPDATE_CLASS_TOTAL:
                this.classLevelCommunicative = this._processLineGraphCommunicative(action.response);
                this.classLevelNoneCommunicative = this._processNoCommunicative(action.response)
                this.emit("UPDATE_CLASS_TOTAL")
                break;

            case Constants.UPDATE_STUDENT_TOTAL:
                this.studentLevelCommunicative = this._processLineGraphCommunicative(action.response);
                this.studentLevelNoneCommunicative = this._processNoCommunicative(action.response);
                this.studentLevelTotalWordsCommunicative = this._processTotalWordsCommunicative(action.response);
                this.emit("UPDATE_STUDENT_TOTAL")
                break;
            case Constants.UPDATE_STUDENT_WORDS_TOTAL:
                this.studentTotal = action.response;
                this.emit("UPDATE_STUDENT_WORDS_TOTAL")
                break
            case Constants.UPDATE_CLASS_WORDS_TOTAL :
                this.classTotal = action.response;
                this.emit("UPDATE_CLASS_WORDS_TOTAL")
                break;
            case Constants.UPDATE_ACCOUNT_TOTAL:
                this.total = action.response;
                this.emitChange();
                break;
        }


    }

    getAccountCommunicative(){
        return this.accountLevelCommunicative;
    }

    getAccountTotal(){
        return this.total;
    }

}

export default new WordsLearntStore();


// WEBPACK FOOTER //
// ./src/store/words-learnt-store.js